import { getForecast } from "@/api/forecast";
import { arrayObjToObjArray } from "@/utils/generics";
import moment from "moment";

export default {
  state: () => ({
    chartObject: null,
  }),
  mutations: {
    SET_FORECAST: (state, payload) => {
      state.chartObject = {
        cobrar: payload.inflows_amount,
        pagar: payload.outflows_amount,
        balance: payload.cash_balance,
        labels: payload.cashflow_date,
      };
    },
  },
  actions: {
    getForecastFlowCash ({commit}) {
      return new Promise((resolve, reject) => {
        getForecast()
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((element) => {
                element.week = moment(
                  element.cashflow_date,
                  "YYYY-MM-DD"
                )
                  .isoWeekday(1)
                  .week();
              });
              // group by for week data
              let grouped = response.data.reduce((prev, current) => {
                if(prev.length> 0 && prev[prev.length - 1][0].week === current.week){
                  prev[prev.length - 1].push(current);
                }
                else{
                  prev.push([current]);
                }
                return prev;
              }, []);
              Object.keys(grouped).forEach((key) => {
                grouped[key] = arrayObjToObjArray(grouped[key]);
                let moments = grouped[key].cashflow_date.map((d) =>
                  moment(d)
                );
                // extract the sunday date of the group
                grouped[key].cashflow_date = moment
                  .max(moments)
                  .format("YYYY-MM-DD");
                // sum all inflows_amount in the group
                grouped[key].inflows_amount = grouped[
                  key
                ].inflows_amount.reduce((a, b) => a + b, 0);
                // sum all outflows_amount in the group
                grouped[key].outflows_amount = grouped[
                  key
                ].outflows_amount.reduce((a, b) => a + b, 0);
                // get last cash_balance in the group
                grouped[key].cash_balance = grouped[
                  key
                ].cash_balance.pop();
              });

              let listObj = [];
              // parse obj of objs to list of objs
              Object.values(grouped).forEach((val) => {
                listObj.push(val);
              });

              let forecast = arrayObjToObjArray(listObj);

              forecast.outflows_amount = forecast.outflows_amount.map(
                (value) => value * -1
              );
              commit('SET_FORECAST', forecast);
            }
            // Resolver SIEMPRE: con data vacía esta promise quedaba colgada
            // para siempre (ni resolve ni reject) y cualquier await se colgaba.
            resolve(true);
          }).catch(error => {
            reject(error);
          });
      });
    },
  },
  getters: {},
  namespaced: true
}
